import { Component, OnInit, ViewChild, Output, EventEmitter } from "@angular/core";
import { FuncionariosService } from "../servicios/funcionarios.service";
import { MatTableDataSource, MatPaginator } from "@angular/material";
import { Globals } from "../../globals";
import { ConsultarPreguntasService } from "src/app/administrador-preguntas/consultar-preguntas.service";
import { Router } from "@angular/router";

@Component({
  selector: "app-buscar-usuario",
  templateUrl: "./buscar-usuario.component.html",
  styleUrls: ["./buscar-usuario.component.css"]
})
export class BuscarUsuarioComponent implements OnInit {
  dataSource = new MatTableDataSource([]);

  loading = true;

  @ViewChild(MatPaginator, { static: false }) paginator: MatPaginator;
  @Output() editarUsuario = new EventEmitter<string>();
  
  displayedColumns: string[] = ["nombre_completo", "correo_corporativo", "nombre_posicion", "nro_persona"];

  funcionariosok = null;

  constructor(private objFuncionario: FuncionariosService, public globals: Globals,private consultarPreguntas: ConsultarPreguntasService, private router: Router) {}

  ngOnInit() {
    this.ConsultarTodosLosFuncionarios();

    //////conole.log(this.globals.contenedorVarGlobal);
  }

  applyFilter(filterValue: string) {
    this.dataSource.filter = filterValue.trim().toLowerCase();
  }

  ConsultarTodosLosFuncionarios() {
    this.objFuncionario.ConsultarTodosLosFuncionarios().subscribe(result => {
      this.funcionariosok = result;

      this.dataSource = new MatTableDataSource(this.funcionariosok);
      this.dataSource.paginator = this.paginator;
      this.loading = false;
    });
  }

  seleccionarusuario(IdusuarioSapFrontera) {
    //////conole.log(IdusuarioSapFrontera);

    this.globals.contenedorVarGlobal = "formulario";
    this.globals.tipoFormularioVarGlobal = "Editar";

    //localStorage.getItem("IdusuarioSapFrontera");
    localStorage.setItem("IdusuarioSapFrontera", IdusuarioSapFrontera);
  }


  historialRespuestas(funcionario){

    this.globals.contenedorVarGlobal = "annio";
    this.globals.funcionarioSeleccionado=funcionario
    this.globals.tipoConsulta="TodasRespuestas"

     
  }

  listarPreguntas(funcionario){
    this.loading=true;
    this.consultarPreguntas.consultaPreguntasCantidad(funcionario).subscribe(rt=>{
      //////conole.log(rt)
      this.globals.contenedorVarGlobal = "preguntas";
      this.globals.tipoConsulta="RespuestaIndividual"
      this.globals.funcionarioSeleccionado=funcionario
      this.globals.listaPreguntas=rt;
      this.loading=false
    })
  }
}
